export default __webpack_public_path__ + "static/media/Screenshot (3).c19b7847.png";